<template>
  <el-form v-model="form" @submit.native.prevent="onSubmit">
    <el-row type="flex" :gutter="20" class="flex" style="align-items: flex-end;">
      <!-- Company -->
      <el-col :xs="24" :sm="5">
        <el-form-item :label="$t('Articles for Widget')">
          <Selects
            :options="widgets"
            :placeholder="$t('Filter by widget')"
            :selected="selectedWidget"
            :filterable="true"
            @on-change="onChangeWidget"
          />
        </el-form-item>
      </el-col>

      <!-- Buttons -->
      <el-col :xs="24" :sm="6">
        <el-form-item>
          <el-button class type="primary" native-type="submit" icon="el-icon-search">
            {{ $t('Search') }}
          </el-button>

          <el-button class="m-l-1" type="text" @click.prevent="clearFilter" icon="el-icon-close">
            {{ $t('Clear filter') }}
          </el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex';
import Selects from '@/components/Select/Select.vue';
import { transformForSelect } from '@/shared/transformers';
import { forEach, uniqBy } from 'lodash';
import { MODULE_NAME as ARTICLES_MODULE } from '@/store/modules/bb_articles';
import { MODULE_NAME as WIDETS_MODULE } from '@/store/modules/bb_widgets';

export default {
  name: 'FormFilterArticles',

  components: {
    Selects
  },

  computed: {
    ...mapGetters({
      allWidgets: `${WIDETS_MODULE}/all`
    }),

    widgets() {
      return transformForSelect(this.allWidgets, { label: 'name', value: 'id' });
    },

    widgetTags() {
      const tags = [];
      // Get available tags by selected widget to filter articles
      if (this.selectedWidget.hasOwnProperty('tags') && Array.isArray(this.selectedWidget.tags)) {
        this.selectedWidget.tags.forEach(tag => {
          tags.push(tag.tag);
        });
      } else {
        return tags;
      }

      const uniqTags = uniqBy(tags, 'id');
      return transformForSelect(uniqTags, { label: 'name', value: 'id' });
    }
  },

  data() {
    return {
      form: {
        'tags.tag.id': {
          in: []
        }
      },
      selectedTags: [],
      selectedWidget: {}
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    clearFilter() {
      this.$store.commit(`${ARTICLES_MODULE}/SET_FILTERS`, {});
      this.selectedWidget = {};

      const form = {};

      forEach(this.form, (value, key) => {
        form[key] = this.clearFilterItem(value);
      });

      this.$set(this.form, form);
      this.onSubmit();
    },

    clearFilterItem(filter) {
      forEach(filter, (value, key) => {
        filter[key] = null;
      });

      return filter;
    },

    init() {
      // If there is a widget available, pre-select it
      if (this.widgets.length) {
        this.onChangeWidget(this.widgets[0]);
        this.onSubmit();
      }
    },

    onChangeWidget(item) {
      this.selectedWidget = {};

      if (item && item.value) {
        this.selectedWidget = item;
      }

      // Clear tag filter
      this.form['tags.tag.id'].in = [];

      // Set tags id from widgets
      if (this.widgetTags.length) {
        this.widgetTags.forEach(item => {
          this.form['tags.tag.id'].in.push(item.id);
        });
      }

      this.$emit('change-widget', this.selectedWidget);
    },

    onSubmit() {
      // Remove empty filter items
      const filters = {};
      forEach(this.form, (value, key) => {
        forEach(value, (value2, key2) => {
          if (value2) {
            filters[key] = {};
            filters[key][key2] = value2;
          }
        });
      });

      this.$store.commit('bb_articles/SET_FILTERS', filters);
      this.$emit('submit');
    }
  },

  destroyed() {
    this.clearFilter();
  },

  watch: {
    widgets(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.init();
      }
    }
  }
};
</script>
